import type { MediaTiming } from "types";
import { analyticsTheme } from "../analyticsTheme";

// Derived from the generated API schema
export type ChapterMilestone = Pick<
  MediaTiming["chapters"][number],
  "chapter_name" | "start_timestamp"
>;

/**
 * Builds the annotation config for a vertical dashed line at each chapter
 * boundary. `start_timestamp` is in ms, the x-axis in seconds, so we divide
 * by 1000. Chapters without a start timestamp are skipped.
 */
export const buildChapterAnnotations = (
  chapters: ChapterMilestone[] | undefined
): Record<string, unknown> => {
  const annotations: Record<string, unknown> = {};

  (chapters ?? []).forEach((chapter, index) => {
    const start = chapter.start_timestamp;
    if (start == null) {
      return;
    }

    const startSeconds = start / 1000;

    annotations[`chapter-${index}`] = {
      type: "line",
      xMin: startSeconds,
      xMax: startSeconds,
      borderColor: analyticsTheme.textMuted,
      borderWidth: 1,
      borderDash: [4, 4],
    };
  });

  return annotations;
};
